<template>
	<Modals
		:title="'Code Details'"
		:validateBeforeClose="validateBeforeClose"
		:display="display"
		@show="close"
		:parentTag="'form'"
		:novalidate="'novalidate'"
		:fullMobile="true"
	>
		<template #modal-content>
			<CodeDetails :snippet="snippet" />
		</template>
		<template #modal-footer>
			<Button
				className="btn--primary"
				labelText="Close"
				:btnClick="close"
			/>
		</template>
	</Modals>
</template>

<script>
import Modals from '@/components/shells/modal/modals';
import Button from '@/components/forms/button/button';
import CodeDetails from '@/views/form-designer/code-details';

export default {
	name: 'CodeDetailsModal',
	components: {
		Modals,
		Button,
		CodeDetails
	},
	model: {
		prop: 'display',
		event: 'show'
	},
	props: {
		title: {
			type: String,
			default: ''
		},
		parentTag: {
			type: String,
			default: 'div'
		},
		validateBeforeClose: {
			type: Boolean,
			default: false
		},
		display: {
			type: Boolean,
			default: false
		},
		snippet: {
			type: Object,
			default: () => {}
		}
	},
	data() {
		return {
			showModal: this.display
		};
	},
	computed: {
		isConfirmation() {
			return this.type == 'confirmation';
		},
		isMobile() {
			return this.$store.getters.screenSize.mobile;
		}
	},
	methods: {
		close() {
			this.$store.dispatch('codemanager/codeSelectedDetails', {});
			this.$store.dispatch('codemanager/showCodeDetailModal', false);
		}
	},
	watch: {
		display: {
			handler() {
				this.showModal = this.display;
			}
		}
	}
};
</script>

<style lang="scss" scoped>
::v-deep .code-details {
	@include mq($from: sm-l) {
		&__primary {
			grid-column: 1/2;
		}

		&__secondary {
			grid-column: 2/4;
		}
	}

	@include mq($from: md) {
		width: 580px;
	}
}
</style>
